import { motion } from "framer-motion";

export const Marquee = ({ items }) => (
  <div className="overflow-hidden bg-jungle py-5 border-y border-teal/20" data-testid="marquee">
    <motion.div
      className="flex gap-10 whitespace-nowrap"
      animate={{ x: ["0%", "-50%"] }}
      transition={{ duration: 28, repeat: Infinity, ease: "linear" }}
    >
      {[...items, ...items].map((it, i) => (
        <span key={i} className="font-heading text-2xl md:text-3xl text-sand/85 flex items-center gap-10">
          {it}
          <span className="text-teal text-lg">✦</span>
        </span>
      ))}
    </motion.div>
  </div>
);
